/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SterWebsiteModelPortalDiscountSurtaxRule
 */
export interface SterWebsiteModelPortalDiscountSurtaxRule {
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPortalDiscountSurtaxRule
   */
  readonly code?: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPortalDiscountSurtaxRule
   */
  readonly description?: string;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPortalDiscountSurtaxRule
   */
  readonly percentage?: number;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPortalDiscountSurtaxRule
   */
  readonly type?: SterWebsiteModelPortalDiscountSurtaxRuleTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum SterWebsiteModelPortalDiscountSurtaxRuleTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
}

export function SterWebsiteModelPortalDiscountSurtaxRuleFromJSON(
  json: any
): SterWebsiteModelPortalDiscountSurtaxRule {
  return SterWebsiteModelPortalDiscountSurtaxRuleFromJSONTyped(json, false);
}

export function SterWebsiteModelPortalDiscountSurtaxRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPortalDiscountSurtaxRule {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    code: !exists(json, "code") ? undefined : json["code"],
    description: !exists(json, "description") ? undefined : json["description"],
    percentage: !exists(json, "percentage") ? undefined : json["percentage"],
    type: !exists(json, "type") ? undefined : json["type"],
  };
}

export function SterWebsiteModelPortalDiscountSurtaxRuleToJSON(
  value?: SterWebsiteModelPortalDiscountSurtaxRule | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {};
}
